import * as React from 'react';
import Api from '../../services/Api';
import { ApiResponse } from 'apisauce';
//import { powerbi } from 'powerbi';
import {
  service,
  factories,
  models,
  IEmbedConfiguration,
} from 'powerbi-client';
import './PowerBiReport.css';

export interface IPowerBiDashboardProps {
  dashboardId: string;
}

const powerbi = new service.Service(
  factories.hpmFactory,
  factories.wpmpFactory,
  factories.routerFactory
);

export default class PowerBiDashboard extends React.Component<
  IPowerBiDashboardProps
> {
  reportRef: React.Ref<HTMLDivElement>;
  reportContainer: HTMLElement;
  loading: JSX.Element;
  constructor(props: IPowerBiDashboardProps) {
    super(props);

    this.state = { accessToken: '', embedUrl: '', error: [] };

    this.reportRef = React.createRef();

    // Report container
    this.loading = (
      <div
        id={'reportContainer'} // + this.props.containerId}
        ref={this.reportRef}
        className='reportContainer'
      >
        Loading the report...
      </div>
    );
  }

  doeEmbed = () => {
    if (this.reportRef !== null) {
      this.reportContainer = this.reportRef['current'];
    }

    Api.get(`PBI/GetEmbedParam?dashboardId=${this.props.dashboardId}`).then(
      (result: ApiResponse<any>) => {
        //const embedData = $.parseJSON(result.data);
        const embedData = result.data;
        const reportLoadConfig = {
          type: 'dashboard',
          tokenType: models.TokenType.Embed,
          accessToken: embedData.accessToken,
          embedUrl: embedData.embedUrl,
          id: this.props.dashboardId,
          pageView: 'fitToWidth',
          /*
                // Enable this setting to remove gray shoulders from embedded report
                settings: {
                    background: models.BackgroundType.Transparent
                }
                */
        };

        // Use the token expiry to regenerate Embed token for seamless end user experience
        // Refer https://aka.ms/RefreshEmbedToken
        const tokenExpiry = embedData.embedTokenExpiry;

        // Embed Power BI report when Access token and Embed URL are available
        var report = powerbi.embed(this.reportContainer, reportLoadConfig);

        // Clear any other loaded handler events
        report.off('loaded');

        // Triggers when a report schema is successfully loaded
        report.on('loaded', function () {
          console.log('Report load successful');
        });

        // Clear any other rendered handler events
        report.off('rendered');

        // Triggers when a report is successfully embedded in UI
        report.on('rendered', function () {
          console.log('Report render successful');
        });

        // Clear any other error handler events
        report.off('error');

        // Handle embed errors
        report.on('error', function (event) {
          var errorMsg = event.detail;

          // Use errorMsg variable to log error in any destination of choice
          console.error(errorMsg);
          return;
        });
      }
    );
  };
  componentDidMount() {
    if (this.reportRef !== null) {
      this.reportContainer = this.reportRef['current'];
    }
  }
  // React function
  componentWillUnmount(): void {
    powerbi.reset(this.reportContainer);
  }
  public render() {
    this.doeEmbed();
    return this.loading;
  }
}
